import React from 'react';
import globalStyles from '../../styles';
import Panel from './Panel';
import FormsOfReceiptsForm from '../../components/Panel/FormsOfReceipts/FormsOfReceiptsForm';
import {Link} from 'react-router';
import urlBase from '../../url-base';


  const styles = {
    tituloPagina: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    breadcrumb: {
      fontSize: 12,
      float: 'right'
    }
  };

const FormsOfReceiptsPage = () => {

  return (
    <Panel>
      <div>
        <div style={styles.breadcrumb}>
          <i className="fa fa-home">&nbsp;</i>
          <Link to={urlBase.client + 'panel'}>Home</Link>
          &nbsp;>&nbsp;
          <Link style={{color:'#505050'}} to={urlBase.client + "panel/formsofreceipts"}>
            Formas de Recebimentos
          </Link>
        </div>

        <h3 style={globalStyles.navigation}>
          Formas de
          <span style={styles.tituloPagina}> Recebimentos</span>
        </h3>

        <FormsOfReceiptsForm />

      </div>
    </Panel>

  );
};

export default FormsOfReceiptsPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/FormsOfReceiptsPage.js
 **/